import { Modal } from 'mdb-ui-kit';
window.Modal = Modal;